import { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Row, Col, CloseButton } from "react-bootstrap";
import { uploadmultiple, companyFolderImages } from "../../utils/admin/admin.service";
import Swal from "sweetalert2";

const UploadIconModal = ({ show, onHide, companyName, uploadToCompanyFolder = false }) => {
    const [loading, setLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [error, setError] = useState('');
    let fileInputRefMultiple = useRef(null);

    const handleImageUploadMultiple = async (event) => {
        setLoading(true);
        const files = Array.from(event.target.files);
        const oversizedFiles = files.filter(file => file.size > 100 * 1024 * 1024); // 100 MB in bytes

        if (files.length > 50) {
            Swal.fire({
                icon: 'error',
                title: 'Oops!',
                text: 'You can only upload up to 50 files.',
                confirmButtonText: 'Ok',
            });
            setLoading(false);
            if (fileInputRefMultiple.current) fileInputRefMultiple.current.value = '';
            return;
        }
        if (oversizedFiles.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'File size exceeds limit!',
                text: 'Each file must be smaller than 100 MB.',
                confirmButtonText: 'Ok',
            });
            setLoading(false);
            if (fileInputRefMultiple.current) fileInputRefMultiple.current.value = '';
            return;
        }
        Swal.fire({
            title: 'Uploading...',
            text: 'Please wait while we upload your files.',
            allowOutsideClick: false,  // Prevent closing the modal during upload
            didOpen: () => {
                Swal.showLoading(); // Show loading spinner
            }
        });

        const formData = new FormData();

        files.forEach(file => {
            formData.append('attachments', file);
        });

        // If uploading to company folder, include companyName in the form data (backend expects either body or query)
        if (uploadToCompanyFolder && companyName) {
            formData.append('companyName', companyName);
        }

        try {
            let response;
            if (uploadToCompanyFolder) {
                response = await companyFolderImages(formData);
            } else {
                response = await uploadmultiple(formData); // Call existing API
            }

            setSelectedFiles(prevFiles => [...prevFiles, ...files]);
            console.log('Upload success:', response);
            console.log('Selected Files:', selectedFiles);
            Swal.close();
        } catch (error) {
            console.error('Error during image upload:', error);
            Swal.fire({
                icon: 'error',
                title: 'Upload Failed',
                text: 'There was an error while uploading the files.',
            });
        } finally {
            // Ensure any Swal loading UI is closed
            try { Swal.close(); } catch (e) { }
            if (fileInputRefMultiple.current) fileInputRefMultiple.current.value = '';
            setLoading(false);
        }
    };

    const handleClose = () => {
        // Prevent closing while upload is in progress
        if (loading) return;
        // reset state when closing
        setSelectedFiles([]);
        setError('');
        if (fileInputRefMultiple.current) fileInputRefMultiple.current.value = '';
        onHide && onHide();
    };

    // Reset state when modal is hidden (in case parent hides it)
    // This also ensures next open starts fresh
    useEffect(() => {
        if (!show) {
            setSelectedFiles([]);
            setError('');
            setLoading(false);
            if (fileInputRefMultiple.current) fileInputRefMultiple.current.value = '';
            try { Swal.close(); } catch (e) { }
        }
    }, [show]);

    const title = uploadToCompanyFolder && companyName ? `Upload Creatives In Company Folder — ${companyName}` : 'Upload Company APP ICONS';

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className='my-0 py-0' keyboard={false} backdrop="static">
            <Modal.Header className='mb-0 pb-0 border-0'>
                {!loading && <CloseButton onClick={handleClose} />}
            </Modal.Header>
            <Modal.Body>
                <h3 className='pb-2 text-box text-center' style={{ color: "var(--primary-color)" }}>{title}</h3>
                <Row className="mt-3">
                    <Col xs={12} lg={12}>
                        <Form.Group controlId="formCompanyLogo">
                            <Form.Label className="text-secondary">{uploadToCompanyFolder ? `Company Creatives` : 'Company Icons'}</Form.Label>
                            <div className="d-flex flex-column align-items-start gap-2">
                                <Button
                                    variant="secondary"
                                    className="py-2 w-100"
                                    style={{ background: "transparent", color: 'var(--color4)', }}
                                    disabled={loading}
                                    onClick={() => fileInputRefMultiple.current.click()}
                                >
                                    {uploadToCompanyFolder ? 'Select Creatives to Upload' : 'Select Icons to Upload'}
                                    <br />
                                    <small className="text-muted" style={{ fontSize: "12px" }}>
                                        Max 50 files, Max 100 MB per file
                                    </small>
                                </Button>
                                <div className="d-flex flex-column align-items-start mt-2 w-100">
                                    <input
                                        type="file"
                                        ref={fileInputRefMultiple}
                                        style={{ display: 'none' }}
                                        accept=".png, .jpg, .jpeg, .gif, .mp4"
                                        onChange={handleImageUploadMultiple}
                                        multiple // Allow multiple files to be selected
                                    />
                                    {selectedFiles?.length > 0 &&
                                        <>
                                            <div className="px-1 w-100">
                                                <strong>Uploaded Icons:</strong>
                                                <ul className="list-group pt-2 w-100">
                                                    {selectedFiles?.map((file, index) => (
                                                        <li key={index} className="list-group-item d-flex align-items-center justify-content-between">
                                                            {file.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {/* <div className="mt-2">
                                                <span className="text-danger">You can upload up to 10 files only.</span>
                                            </div> */}
                                        </>
                                    }
                                </div>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end mt-3 pt-2">
                    <Button onClick={handleClose} className='bg-secondary px-4 py-2 border-0' disabled={loading}>Cancel</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default UploadIconModal;
